
  <div class="cards-add"  *ngIf="editMode">
    <span>Группа изображений</span>
    <ico ico="add_circle_24" (click)="add()"></ico>
  </div>  

<cards-section-items [section]="section" [type]="type" [editMode]="editMode"></cards-section-items>
